export default {
  english: {
    label: 'More news',
    link: '/en/news/more-news',
    sponsored: 'Partnership',
  },
  french: {
    label: 'Plus d\'actualités',
    link: '/fr/actu/plus-d-actualites',
    sponsored: 'Partenariat',
  },
  arabic: {
    label: 'المزيد من الأخبار',
    link: '/ar/أخبار/المزيد من الأخبار',
    sponsored: 'ممول',
  },
  hebrew: {
    label: 'עוד חדשות',
    link: '/he/news/more-news',
    sponsored: 'בשיתוף',
  },
  persian: {
    label: 'اخبار بیشتر',
    link: '/fa/news/more-news',
    sponsored: 'شراکت',
  },
}
